/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import { useTranslate } from "../../../hooks/useTranslate";

const StyledFormGroup = styled.fieldset`
  display: grid;
  gap: 8px;
`;

const StyledLegend = styled.legend`
  padding: 0;
  font-size: calc(${({ theme }) => theme.fontSizes.p} * 0.875);
  color: rgba(${({ theme }) => theme.colors.text.rgba});
`;

// Most usages wrap a single labelled field, so `legend` is opt-in: pass it only
// when the group genuinely bundles multiple related controls (e.g. a set of
// checkboxes/radios), otherwise the field's own <label> is the accessible name.
const FormGroup = ({ children, legend }) => {
  const { _t } = useTranslate();

  return (
    <StyledFormGroup>
      {legend && <StyledLegend>{_t(legend)}</StyledLegend>}
      {children}
    </StyledFormGroup>
  );
};

export default FormGroup;
